export const LOCATIONS: any = {
    'Chile': {
        prefix: '+56',
        idName: 'RUT',
        idPlaceholder: '12.345.678-K',
        regions: {
            'Arica y Parinacota': ['Arica', 'Putre', 'Camarones', 'General Lagos'],
            'Tarapacá': ['Iquique', 'Alto Hospicio', 'Pozo Almonte', 'Pica', 'Huara'],
            'Antofagasta': ['Antofagasta', 'Calama', 'Tocopilla', 'Mejillones', 'Taltal', 'San Pedro de Atacama'],
            'Atacama': ['Copiapó', 'Vallenar', 'Caldera', 'Chañaral', 'Tierra Amarilla', 'Diego de Almagro'],
            'Coquimbo': ['La Serena', 'Coquimbo', 'Ovalle', 'Illapel', 'Vicuña', 'Salamanca', 'Los Vilos', 'Andacollo'],
            'Valparaíso': ['Valparaíso', 'Viña del Mar', 'Concón', 'Quilpué', 'Villa Alemana', 'San Antonio', 'Quillota', 'Los Andes', 'San Felipe', 'Limache'],
            'Metropolitana': [
                'Santiago', 'Providencia', 'Las Condes', 'Vitacura', 'Ñuñoa', 'La Florida', 'Maipú', 'Puente Alto',
                'San Miguel', 'La Reina', 'Peñalolén', 'Macul', 'Estación Central', 'Recoleta', 'Independencia',
                'Quilicura', 'Pudahuel', 'San Bernardo', 'Buin', 'Paine', 'Colina', 'Lampa'
            ],
            'O\'Higgins': ['Rancagua', 'San Fernando', 'Rengo', 'Machalí', 'San Vicente', 'Santa Cruz', 'Chimbarongo'],
            'Maule': ['Talca', 'Curicó', 'Linares', 'Constitución', 'Cauquenes', 'Molina', 'Parral', 'San Javier'],
            'Ñuble': ['Chillán', 'San Carlos', 'Coihueco', 'Bulnes', 'Chillán Viejo', 'Quillón'],
            'Biobío': ['Concepción', 'Talcahuano', 'Los Ángeles', 'San Pedro de la Paz', 'Chiguayante', 'Coronel', 'Hualpén', 'Tomé', 'Arauco'],
            'Araucanía': ['Temuco', 'Villarrica', 'Pucón', 'Padre Las Casas', 'Angol', 'Victoria', 'Lautaro'],
            'Los Ríos': ['Valdivia', 'La Unión', 'Río Bueno', 'Panguipulli', 'Futrono', 'Los Lagos'],
            'Los Lagos': ['Puerto Montt', 'Puerto Varas', 'Osorno', 'Castro', 'Ancud', 'Frutillar', 'Llanquihue', 'Calbuco'],
            'Aysén': ['Coyhaique', 'Puerto Aysén', 'Chile Chico', 'Cochrane'],
            'Magallanes': ['Punta Arenas', 'Puerto Natales', 'Porvenir']
        }
    },
    'Argentina': {
        prefix: '+54 9',
        idName: 'DNI',
        idPlaceholder: '88.888.888',
        regions: {
            'Buenos Aires': ['CABA', 'La Plata', 'Mar del Plata', 'Bahía Blanca', 'Tandil'],
            'Córdoba': ['Córdoba', 'Villa Carlos Paz', 'Río Cuarto', 'Alta Gracia'],
            'Santa Fe': ['Rosario', 'Santa Fe', 'Rafaela', 'Venado Tuerto'],
            'Mendoza': ['Mendoza', 'San Rafael', 'Godoy Cruz', 'Luján de Cuyo']
        }
    },
    'Perú': {
        prefix: '+51',
        idName: 'DNI',
        idPlaceholder: '00000000',
        regions: {
            'Lima': ['Lima', 'Miraflores', 'San Isidro', 'Barranco', 'Surco'],
            'Arequipa': ['Arequipa', 'Cayma', 'Yanahuara'],
            'Cusco': ['Cusco', 'Urubamba'],
            'La Libertad': ['Trujillo', 'Huanchaco']
        }
    },
    'Colombia': {
        prefix: '+57',
        idName: 'Cédula',
        idPlaceholder: '00.000.000.000',
        regions: {
            'Bogotá D.C.': ['Bogotá', 'Usaquén', 'Chapinero'],
            'Antioquia': ['Medellín', 'Envigado', 'Sabaneta', 'Bello'],
            'Valle del Cauca': ['Cali', 'Palmira', 'Buga'],
            'Atlántico': ['Barranquilla', 'Soledad']
        }
    },
    'México': {
        prefix: '+52',
        idName: 'CURP',
        idPlaceholder: 'ABCD123456...',
        regions: {
            'CDMX': ['Coyoacán', 'Polanco', 'Condesa', 'Roma', 'Santa Fe'],
            'Jalisco': ['Guadalajara', 'Zapopan', 'Puerto Vallarta', 'Tlaquepaque'],
            'Nuevo León': ['Monterrey', 'San Pedro', 'San Nicolás'],
            'Yucatán': ['Mérida', 'Valladolid']
        }
    },
    'España': {
        prefix: '+34',
        idName: 'DNI/NIE',
        idPlaceholder: '12345678Z',
        regions: {
            'Madrid': ['Madrid', 'Alcalá de Henares', 'Getafe', 'Leganés'],
            'Cataluña': ['Barcelona', 'L\'Hospitalet', 'Badalona', 'Terrassa'],
            'Andalucía': ['Sevilla', 'Málaga', 'Granada', 'Córdoba'],
            'Valencia': ['Valencia', 'Alicante', 'Elche']
        }
    },
    'Uruguay': {
        prefix: '+598',
        idName: 'C.I.',
        idPlaceholder: '0.000.000-0',
        regions: {
            'Montevideo': ['Montevideo', 'Ciudad de la Costa', 'Las Piedras'],
            'Maldonado': ['Maldonado', 'Punta del Este', 'San Carlos'],
            'Canelones': ['Canelones', 'Pando', 'La Paz']
        }
    },
    'Paraguay': {
        prefix: '+595',
        idName: 'C.I.',
        idPlaceholder: '0.000.000',
        regions: {
            'Asunción': ['Asunción', 'Luque', 'Lambaré'],
            'Central': ['San Lorenzo', 'Capiatá', 'Fernando de la Mora'],
            'Alto Paraná': ['Ciudad del Este', 'Hernandarias', 'Presidente Franco']
        }
    },
    'Venezuela': {
        prefix: '+58',
        idName: 'Cédula',
        idPlaceholder: 'V-00.000.000',
        regions: {
            'Caracas': ['Caracas', 'Chacao', 'Baruta'],
            'Miranda': ['Los Teques', 'Guatire', 'Guarenas'],
            'Zulia': ['Maracaibo', 'San Francisco', 'Cabimas']
        }
    },
    'Ecuador': {
        prefix: '+593',
        idName: 'Cédula',
        idPlaceholder: '000000000-0',
        regions: {
            'Pichincha': ['Quito', 'Sangolquí', 'Cayambe'],
            'Guayas': ['Guayaquil', 'Durán', 'Samborondón'],
            'Azuay': ['Cuenca', 'Gualaceo', 'Paute']
        }
    },
    'Bolivia': {
        prefix: '+591',
        idName: 'C.I.',
        idPlaceholder: '0000000',
        regions: {
            'La Paz': ['La Paz', 'El Alto', 'Viacha'],
            'Santa Cruz': ['Santa Cruz de la Sierra', 'Montero', 'Warnes'],
            'Cochabamba': ['Cochabamba', 'Sacaba', 'Quillacollo']
        }
    },
    'Costa Rica': {
        prefix: '+506',
        idName: 'Cédula',
        idPlaceholder: '0-0000-0000',
        regions: {
            'San José': ['San José', 'Desamparados', 'Alajuelita'],
            'Alajuela': ['Alajuela', 'San Carlos', 'Naranjo'],
            'Heredia': ['Heredia', 'San Francisco', 'Belén']
        }
    },
    'Panamá': {
        prefix: '+507',
        idName: 'Cédula',
        idPlaceholder: '00-0000-0000',
        regions: {
            'Panamá': ['Ciudad de Panamá', 'San Miguelito', 'Tocumen'],
            'Chiriquí': ['David', 'Bugaba', 'Boquete'],
            'Panamá Oeste': ['La Chorrera', 'Arraiján']
        }
    },
    'Guatemala': {
        prefix: '+502',
        idName: 'DPI',
        idPlaceholder: '0000 00000 0000',
        regions: {
            'Guatemala': ['Ciudad de Guatemala', 'Mixco', 'Villa Nueva'],
            'Quetzaltenango': ['Quetzaltenango', 'Coatepeque'],
            'Escuintla': ['Escuintla', 'Santa Lucía Cotzumalguapa']
        }
    },
    'Honduras': {
        prefix: '+504',
        idName: 'Identidad',
        idPlaceholder: '0000-0000-00000',
        regions: {
            'Francisco Morazán': ['Tegucigalpa', 'Comayagüela'],
            'Cortés': ['San Pedro Sula', 'Choloma', 'La Lima'],
            'Atlántida': ['La Ceiba', 'Tela']
        }
    },
    'El Salvador': {
        prefix: '+503',
        idName: 'DUI',
        idPlaceholder: '00000000-0',
        regions: {
            'San Salvador': ['San Salvador', 'Soyapango', 'Mejicanos'],
            'Santa Ana': ['Santa Ana', 'Chalchuapa'],
            'La Libertad': ['Santa Tecla', 'Antiguo Cuscatlán']
        }
    },
    'Nicaragua': {
        prefix: '+505',
        idName: 'Cédula',
        idPlaceholder: '000-000000-0000A',
        regions: {
            'Managua': ['Managua', 'Ciudad Sandino', 'Tipitapa'],
            'León': ['León', 'La Paz Centro'],
            'Granada': ['Granada', 'Nandaime']
        }
    },
    'República Dominicana': {
        prefix: '+1 809',
        idName: 'Cédula',
        idPlaceholder: '000-0000000-0',
        regions: {
            'Distrito Nacional': ['Santo Domingo'],
            'Santiago': ['Santiago de los Caballeros', 'Tamboril'],
            'La Vega': ['La Vega', 'Jarabacoa']
        }
    },
    'United States': {
        prefix: '+1',
        idName: 'SSN',
        idPlaceholder: '000-00-0000',
        regions: {
            'California': ['Los Angeles', 'San Francisco', 'San Diego', 'Sacramento'],
            'New York': ['New York City', 'Buffalo', 'Albany'],
            'Texas': ['Houston', 'Austin', 'Dallas', 'San Antonio'],
            'Florida': ['Miami', 'Orlando', 'Tampa', 'Jacksonville']
        }
    }
};
